import React, { useState, useEffect, useRef } from 'react'

const OptionalCookieMessage = (props) => {

    const modalBtnRef = useRef(null)

    useEffect(() => {
        const handleModalClick = event => {
            OptInModal()
        }

        const modalBtn = modalBtnRef.current

        if(modalBtn != null) {
            modalBtn.addEventListener("click", handleModalClick)
            
            //Remove the event listener afterwards so we don't leak memory
            return () => {
                modalBtn.removeEventListener("click", handleModalClick)
            }
        }
    }, [])
    
    return (
        <div className="optional-cookies">
            Optional cookies must be enabled to view this video. <a className="btn btn-small" ref={modalBtnRef}>Manage cookies</a>
        </div>
    )
}

export default OptionalCookieMessage;